import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export const searchItems = (items, q) => {
    const s = q.trim().toLowerCase();
    if (s.length < 2) return [];
    return items.filter((i) => i.name.toLowerCase().includes(s) || (i.hsn || "").includes(s)).slice(0, 8);
};

export const ItemNameInput = ({ value, items, onType, onPick, idx }) => {
    const [pos, setPos] = useState(null);
    const ref = useRef(null);
    const show = () => {
        const r = ref.current.getBoundingClientRect();
        const below = window.innerHeight - r.bottom - 8;
        setPos(below >= 220 || below >= r.top
            ? { top: r.bottom + 4, left: r.left, maxHeight: Math.min(256, below) }
            : { bottom: window.innerHeight - r.top + 4, left: r.left, maxHeight: Math.min(256, r.top - 8) });
    };
    const hits = pos ? searchItems(items, value) : [];
    useEffect(() => {
        if (!pos) return;
        const h = (e) => { if (!e.target.closest?.("[data-po-suggest]")) setPos(null); };
        window.addEventListener("scroll", h, true);
        return () => window.removeEventListener("scroll", h, true);
    }, [pos]);
    return (
        <>
            <input ref={ref} className="hdb-input" value={value} placeholder="Type to search item master…"
                   onChange={(e) => { onType(e.target.value); show(); }}
                   onFocus={show} onBlur={() => setTimeout(() => setPos(null), 150)}
                   data-testid={`po-line-name-${idx}`}/>
            {hits.length > 0 && createPortal(
                <div data-po-suggest style={{ position: "fixed", ...pos }}
                     className="z-[60] w-80 max-w-[80vw] bg-white border border-slate-200 rounded-lg shadow-xl overflow-y-auto"
                     data-testid={`po-line-suggest-${idx}`}>
                    {hits.map((it) => (
                        <button key={it.id} type="button" onMouseDown={(e) => e.preventDefault()}
                                onClick={() => { onPick(it); setPos(null); }} data-testid={`po-line-hit-${idx}-${it.id}`}
                                className="w-full text-left px-3 py-2 text-sm hover:bg-slate-50 flex justify-between gap-2">
                            <span className="font-semibold">{it.name}</span>
                            <span className="text-xs text-slate-400 shrink-0">{it.category} · {it.tax_percent}%</span>
                        </button>
                    ))}
                </div>, document.body)}
        </>
    );
};
